module.exports = "/_next/static/images/profile-mal-261e46f7ddf42c9dc2e141ea3a6c9774.png";